// auth context constants
export const AUTH_CHECK = "AUTH_CHECK";
export const SIGN_IN = "SIGN_IN";
export const SIGN_OUT = "SIGN_OUT";
export const AUTH_STATE_CHANGE = "AUTH_STATE_CHANGE";
export const AUTH_TOKEN = "AUTH_TOKEN";
export const USER_DATA = "USER_DATA";
export const AUTH_STATE_UPDATE = "AUTH_STATE_UPDATE";
export const AUTH_STATE_DONE = "AUTH_STATE_DONE";
export const SET_PROFILE = "SET_PROFILE";

export const STATE_DONE = "STATE_DONE";
export const STATE_WAIT = "STATE_WAIT";

export const LOGO_IMG = () => (
  <img 
    src="/logo.png" 
    alt="Omantel Logo" 
    style={{ height: '45px', width: 'auto', maxWidth: '200px' }}
  />
);
